<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import config from "$lib/config/config";

  export let token: string;
  export let subjectType: number;
  export let subjectId: string;

  const dispatch = createEventDispatcher();

  $: campaignAdminLink = `https://${config.ADMIN_HOST}/${config.SHOPIFY_STORE}/campaigns/${subjectId}`;

  function handleClear() {
    dispatch("clear");
  }
</script>

<style lang="scss">
  .preview-controls {
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1100;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0.6rem 1.4rem;
    border-radius: 2rem;
    text-align: center;

    &__inner {
      margin: 0 0.4rem;
    }
  }

  button {
    background: transparent;
    transition: background 0.3s;
    border: 1px solid rgba(0, 0, 0, 0.8);
    border-radius: 1rem;
    padding: 0.4rem 0.8rem;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
</style>

{#if token}
  <div class="preview-controls">
    <strong class="preview-controls__inner">Preview</strong>
    <span class="preview-controls__inner">
      {#if subjectType === 0}
        Page:
      {:else if subjectType === 1}
        Nav:
      {:else if subjectType === 2}
        <a target="_blank" rel="noreferrer" href={campaignAdminLink}>Campaign</a
        >
      {/if}
      {#if subjectType != 2}
        {subjectId}
      {/if}
    </span>
    <button class="preview-controls__inner" on:click={handleClear}>Exit</button>
  </div>
{/if}
